import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AutotextService } from 'src/app/autotext.service';
import { ExamsService } from 'src/app/exams.service';
import { GastroService } from 'src/app/gastro.service';
import { LoginService } from 'src/app/login.service';
import { PathologyService } from 'src/app/pathology.service';
import  gastroDiagnosisList  from '../../../assets/tables/gastroDiagnosis.json'
import { HttpClient } from '@angular/common/http';
import { MedicationService } from 'src/app/medication.service';
import { Exam } from '../../interfaces/exams.service/types'
import { SignatureService } from 'src/app/signature.service';
import { PatientsService } from 'src/app/patients.service';
import { PdfprintService } from 'src/app/pdfprint.service';

@Component({
    selector: 'app-gastro-summary',
    templateUrl: './gastro-summary.component.html',
    styleUrls: ['./gastro-summary.component.scss'],
    standalone: false
})
export class GastroSummaryComponent implements OnInit {
  gastroList:any;
  // search:any;
  @ViewChild('inputDiagnosis') inputDiagnosis: ElementRef;
  filteredOptions: Observable<string[]>;
  options: any[] = [];
  search = new UntypedFormControl();
  resetS = new UntypedFormControl();
  sub = new Subscription();
  formLoadedSub = new Subscription();
  showPrintOpts: boolean = false;
  signed:Date;
  signer:String;
  itemId;
  recoverySTR:string =`המטופל משתחרר כשהוא מתמצא בזמן ובמקום, רפלקס בליעה ושיעול שמורים\nמצב המודינמי יציב, ללא בחילות הקאות או כאבי בטן משמעותיים.`
  dissmissionSTR=`יש לחזור הביתה בליווי, למנוחה של מספר שעות. עקב קבלת הטשטוש חל איסור מוחלט על נהיגה בשמונה השעות הקרובות.\nייתכן ויהיו לך תופעות של אי נוחות -נפיחות, כאב בטן, גזים ,דימום קל. אלו תופעות מוכרות ולרוב אינן מעוררות דאגה. אם יופיעו אחד מהסימנים הבאים: כאב חזק מהרגיל בבטן, עליית חום, דימום ממערכת העיכול, צואה שחורה, או דם בצואה (למעט שרידי דם בניגוב דם ודם לאחר פעולת מעיים), נמליץ לך לפנות מיד לחדר המיון הקרוב למקום מגוריך, כאשר בידך דו"ח הבדיקה.\nבמידה ונלקחו ביופסיות במהלך הבדיקה, מומלץ מעקב אחרי תוצאות הביופסיות דרך הרופא המטפל/ המפנה.`
  pathologyError=false
  xmlMode 
  xmlLoading=false;
  labelPrinted=false;
  
  constructor(
    public gastroService: GastroService,
    public medicationService: MedicationService,
    public atS: AutotextService,
    public es: ExamsService,
    public ls: LoginService,
    private http: HttpClient,
    public signatureService: SignatureService,
    public patientService: PatientsService,
    public pdfService: PdfprintService,
    public pathologyService: PathologyService
  ) {}

  ngOnInit() {

    if(this.gastroService.gastroForm.get('Recovery').value == null || this.gastroService.gastroForm.get('Recovery').value == '' ){
      this.gastroService.gastroForm.get('Recovery').setValue(this.recoverySTR, {emitEvent:false})
    }
    if(this.gastroService.gastroForm.get('Dissmission').value == null || this.gastroService.gastroForm.get('Dissmission').value == ''){
      this.gastroService.gastroForm.get('Dissmission').setValue(this.dissmissionSTR, {emitEvent:true})
    }
    this.gastroList = gastroDiagnosisList;
    this.filteredOptions = this.search.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value)),
      );
      this.gastroService.buildList();
      this.atS.showAuto(this.search, 'Diagnosis',89, false);
      this.getText();
      this.sub = this.gastroService.diagnosisChange$.subscribe(() => {
        this.gastroService.buildList();
        this.getText();

      })
    if(this.es.isClosed){
      this.search.disable({emitEvent:false})
      this.gastroService.getClosing().subscribe((d:any) => {
        this.signed = d.ClosedDate;
        this.signer = this.ls.getUserName();
      })
    }
    // if(!this.formLoadedSub){
      this.formLoadedSub = this.es.formLoaded$.subscribe(()=>{
        this.gastroService.buildList();
        if(this.gastroService.gastroForm.get('Dissmission').value == null || this.gastroService.gastroForm.get('Dissmission').value == ''){
          this.gastroService.gastroForm.get('Dissmission').setValue(this.dissmissionSTR)
        }
      })
    // }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.gastroList.filter(option => option.value.toLowerCase().includes(filterValue));
  }

  private _reset(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.gastroList.filter(option => option.value.toLowerCase().includes(filterValue));
  }

  reset(){
    this.search.patchValue('');
    // this.resetS.patchValue('');
    this.filteredOptions = this.search.valueChanges.pipe(startWith(''),map(value => this._filter(value)));
  }

  blur(): void {;
    setTimeout(() => this.inputDiagnosis.nativeElement.blur(), 0);
  }

  signClose(){
    this.gastroService.signExam(this.ls.getUserName()).subscribe((d)=>{
      this.signer = this.ls.getUserName();
      this.signed = new Date();
      this.gastroService.gastroForm.disable({emitEvent: false});
      this.search.disable({emitEvent:false})
      this.es.isClosed = true;
    },(error)=>{
      console.log(error);
    })
  }
  getText(){
    var res = this.atS.getTexts();
      this.sub = res.subscribe((data:any) => {
        this.atS.summaryDiagnosisAT = data;
        if((this.gastroList.length - data.length) != 130)
          data.forEach((d) => {
            this.gastroList.push({value: d.Text})
          })
          this.search.patchValue('');
      })
  }

  addToList(option, inATS){
    if(inATS){
      if(this.search.value)
      this.atS.showAuto(this.search, 'Diagnosis', 89,false)
      var res = this.atS.saveText(this.search.value, null)
      this.sub = res.subscribe((data)=>{
        if(this.itemId == null)
          this.itemId = data['insertId'];
          this.gastroService.saveDiagnosis(data, inATS)
          // gs.saveDiagnosis(option);
      },(error)=>{
        console.log(error);
      });
    }else{
      this.gastroService.saveDiagnosis(option)
    }
    
  }
  checkIn(){

    if(this.search.value){
      this.filteredOptions = this.gastroList.filter((option) => {
        if(option.value.includes(this.search.value)){
          this.options.push(option.value)
        }
        return option.value.includes(this.search.value)
     
      });
      
      
      return this.gastroList.filter((option) => option.value.includes(this.search.value)).length > 0;
    }
  }

 async signExam(showPrint: boolean = false) {
    const examId = this.es.examID;
    const data = {
      signedBy: this.ls.getUserName(),
      signedDate: new Date(),
    };

    try {
      this.http.post(`/api/newExams/signature/sign/${examId}`, data)
      .subscribe((data: Exam) => {
            const printLanguage = "he-IL"; 
            if (showPrint) {
              this.es.exitExam();
              this.gastroService.gastroForm.disable({emitEvent:false})
              this.medicationService.Medication.disable({emitEvent:false})
              this.pathologyService.pathologyForm.disable({ emitEvent: false });
              this.es.examSigned$.next(data);
              this.showPrintOpts = true;
            } else {
              this.es.exitExam();
              this.gastroService.gastroForm.disable({ emitEvent: false });
              this.medicationService.Medication.disable({ emitEvent: false });
              this.pathologyService.pathologyForm.disable({ emitEvent: false });
              this.es.isClosed = true;
              this.showPrintOpts = false;
              this.es.examSigned$.next(data);
              this.http
                .get(
                  `/api/printpdf/${this.es.examID}/${
                    this.es.patServ.getPat().PID
                  }/${printLanguage}/${this.pdfService.printCharts ? "y" : "n"}/${
                    this.pdfService.printImages ? "y" : "n"
                  }/${this.pdfService.Style}/${this.pdfService.perPage}/n`
                )
                .subscribe(
                  () => {},
                  (error) => {
                    console.log(error);
                  }
                );
            }
        });
    } catch (error) {
      console.log(error);
    }
  }

  
  closePreview(event$: string) {
    if (event$ === "sign") {
      this.signExam(false);
    } else if (event$ === "signShowPrint") {
      this.signExam(true);
    }
    this.showPrintOpts = false;
  }

  async printPathologyForm() {
    let printUrl: string;
    let autoIndex;
    if(!this.gastroService.gastroForm.get('Reasone').value){
     return this.pathologyError=true
    }

    // Check if no samples have been taken
    if (!this.pathologyService.pathologies || this.pathologyService.pathologies.length === 0) {
      this.pathologyError = true;
      return;
    }

    if (this.es.examID) {
      autoIndex = this.es.examID
      printUrl = `api/gastro/pathologyFormPrint/${autoIndex}`;
      window.open(printUrl);
    } 
    return

  }

  ngOnDestroy() {
    if (this.formLoadedSub) {
      this.formLoadedSub.unsubscribe();
    }
  }

  downloadXml(examId=this.es.examID, xmlMode=this.xmlMode): void {
    if (!examId || !xmlMode) return;
    this.xmlLoading=true
    this.es.xmlDownloadByExamId(examId, xmlMode).subscribe((xml: any) => {
      const blob = new Blob([xml], { type: 'application/xml' });
      const fileName=this.massageID()+xmlMode
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${fileName}.xml`;
      link.click();
      this.xmlLoading=false
    }),
    (error: any) => {
      console.error('Error downloading XML:', error);
      this.xmlLoading = false;
      // You may add additional error handling if needed
    };
  }

   massageID=(examId=this.es.examID,patId=this.patientService.getPat().ID)=>{
    let examCode = examId.toString(32);


    return `${patId}${examCode}`
}
  

secondCommitment(){
if (this.gastroService.awlForm.get('ExamCode').value === 'Gastro-Colonoscopy' && this.es.ExamType === 'Colonoscopy' && (this.gastroService.awlForm.get('HMO').value == 'Clalit' || this.gastroService.awlForm.get('HMO').value == 'Leumit') ){
  return true
}
if (this.gastroService.awlForm.get('ExamCode').value === 'Gastro-Sigmo' && this.es.ExamType === 'Sigmoidoscopy' && (this.gastroService.awlForm.get('HMO').value == 'Clalit' || this.gastroService.awlForm.get('HMO').value == 'Leumit') ){
return true
}
return false
}
}
